import { render } from "./NoticeWrite.vue?vue&type=template&id=b4baf514"
import script from "./NoticeWrite.vue?vue&type=script&lang=js"
export * from "./NoticeWrite.vue?vue&type=script&lang=js"

import "./NoticeWrite.vue?vue&type=style&index=0&id=b4baf514&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__